import {Howl, Howler} from "howler";
import * as PIXI from "pixi.js";
import data from "../configs/data";
import {Button} from "../controlElements/Button";
import {CheckBox} from "../controlElements/CheckBox";
import {Paytable} from "../Paytable";

export class OptionsMenu extends PIXI.Container {

    private volumeCheckBox: CheckBox;
    private infoButton: Button;

    private readonly VOLUME_CHECKBOX_POSITION = new PIXI.Point(0, 12);
    private readonly INFO_BUTTON_POSITION = new PIXI.Point(0, -55);
    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    constructor() {
        super();

        this.createAndAddBackground();
        this.createVolumeCheckbox();
        this.createInfoButton();
    }

    private createVolumeCheckbox(): void {
        this.volumeCheckBox = new CheckBox(data.images.volumeOffBase, data.images.volumeOffHover,
            data.images.volumeOffClick, data.images.volumeOffClick, data.images.volumeOnBase,
            data.images.volumeOnHover, data.images.volumeOnClick,
            data.images.volumeOnClick, data.audios.buttonClicked);
        this.volumeCheckBox.checked = true;
        this.volumeCheckBox.position = this.VOLUME_CHECKBOX_POSITION;
        this.addChild(this.volumeCheckBox);
        this.volumeCheckBox.subscribeOnClicked((isChecked) => {
            if (isChecked) {
                Howler.volume(1.0);
            } else {
                Howler.volume(0.0);
            }
        });
    }

    private createInfoButton(): void {
        this.infoButton = new Button(data.images.infoBase, data.images.infoHover, data.images.infoClick,
            data.images.infoClick, data.audios.buttonClicked);
        this.infoButton.position = this.INFO_BUTTON_POSITION;
        this.addChild(this.infoButton);
        this.infoButton.subscribeOnClicked(() => {
            Paytable.getInstance().toggleVisibility();
        });
    }

    private createAndAddBackground(): void {
        const background = new PIXI.Sprite(PIXI.Texture.fromFrame(data.images.optionsBackground));
        background.interactive = true;
        background.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(background);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/OptionsMenu.ts